"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SECONDARY_HEADER_FONT = exports.PRIMARY_FONT = exports.HEADER_FONT = void 0;
var HEADER_FONT = "'Gothic A1', sans-serif";
exports.HEADER_FONT = HEADER_FONT;
var PRIMARY_FONT = "'Gothic A1', sans-serif";
exports.PRIMARY_FONT = PRIMARY_FONT;
var SECONDARY_HEADER_FONT = "'Poppins', sans-serif";
exports.SECONDARY_HEADER_FONT = SECONDARY_HEADER_FONT;